/* tslint:disable */
/* eslint-disable */
/**
 * Warpgate Web Admin
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.17.0-32-g054b9b1a-modified
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ExistingOtpCredential interface.
 */
export function instanceOfExistingOtpCredential(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    return true;
}
export function ExistingOtpCredentialFromJSON(json) {
    return ExistingOtpCredentialFromJSONTyped(json, false);
}
export function ExistingOtpCredentialFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
    };
}
export function ExistingOtpCredentialToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
    };
}
